import { apiFetch } from "./apiClient";
import type { AuditFields } from "./audit";

/** Maps to the backend's UserDto — the real, live Users resource. */
export interface UserDto extends AuditFields {
  userId: number;
  accountId: number;
  branchId: number | null;
  userName: string;
  email: string;
  mobileNo: string;
  roleId: number;
  roleName: string;
  isActive: boolean;
}

export interface CreateUserPayload {
  accountId: number;
  branchId: number | null;
  userName: string;
  email: string;
  password: string;
  mobileNo: string;
  roleId: number;
  isActive: boolean;
}

export interface UpdateUserPayload {
  accountId: number;
  branchId: number | null;
  userName: string;
  email: string;
  mobileNo: string;
  roleId: number;
  isActive: boolean;
}

export const listUsers = async (): Promise<UserDto[]> => {
  const res = await apiFetch("/users");
  return res.json();
};

export const createUser = async (
  accountId: number,
  payload: CreateUserPayload
): Promise<UserDto> => {
  const res = await apiFetch(`/users/create/${accountId}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};

export const updateUser = async (
  userId: number,
  payload: UpdateUserPayload
): Promise<void> => {
  await apiFetch(`/users/${userId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
};

/** Admin/SuperAdmin setting another user's password — no current password
 * needed (backend: PUT /users/{id}/reset-password). */
export const resetUserPassword = async (
  userId: number,
  newPassword: string
): Promise<void> => {
  await apiFetch(`/users/${userId}/reset-password`, {
    method: "PUT",
    body: JSON.stringify({ newPassword }),
  });
};

export const deleteUser = async (userId: number): Promise<void> => {
  await apiFetch(`/users/${userId}`, { method: "DELETE" });
};
